document.addEventListener('DOMContentLoaded', function () {
  var variantSelects = document.querySelector('variant-selects[data-section]');
  if (!variantSelects) return;
  var sectionId = variantSelects.dataset.section;
  var productUrl = variantSelects.dataset.url;
  fetch(productUrl + '.js').then(function(r){return r.json();}).then(function(product) {
    if (!product.options || product.options.length < 2) return;
    var assignedIds = {};
    product.variants.forEach(function(v) { if (v.featured_image) assignedIds[v.featured_image.id] = true; });
    var componentMedia = product.media.filter(function(m) { return m.media_type === 'image' && !assignedIds[m.id]; });
    if (componentMedia.length === 0) return;
    function norm(str) { return (str || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function words(str) { return (str || '').toLowerCase().replace(/[^a-z ]/g, '').trim().split(/\s+/); }
    var COMPONENT_KEYS = ['case', 'hat', 'bucket', 'goggle', 'cover'];
    function findMatch(color) {
      var colorNorm = norm(color);
      var colorWords = words(color);
      var fn, hasComp, hasSomeColor, altNorm;
      for (var i = 0; i < componentMedia.length; i++) { fn = norm(componentMedia[i].src.split('/').pop().split('?')[0]); hasComp = COMPONENT_KEYS.some(function(k){ return fn.indexOf(k) !== -1; }); if (hasComp && fn.indexOf(colorNorm) !== -1) return componentMedia[i]; }
      for (var i = 0; i < componentMedia.length; i++) { fn = norm(componentMedia[i].src.split('/').pop().split('?')[0]); hasComp = COMPONENT_KEYS.some(function(k){ return fn.indexOf(k) !== -1; }); hasSomeColor = colorWords.some(function(w){ return w.length > 2 && fn.indexOf(w) !== -1; }); if (hasComp && hasSomeColor) return componentMedia[i]; }
      for (var i = 0; i < componentMedia.length; i++) { altNorm = norm(componentMedia[i].alt || ''); if (altNorm === colorNorm) return componentMedia[i]; }
      for (var i = 0; i < componentMedia.length; i++) { fn = norm(componentMedia[i].src.split('/').pop().split('?')[0]); if (fn.indexOf(colorNorm) !== -1) return componentMedia[i]; }
      for (var i = 0; i < componentMedia.length; i++) { fn = norm(componentMedia[i].src.split('/').pop().split('?')[0]); hasSomeColor = colorWords.some(function(w){ return w.length > 2 && fn.indexOf(w) !== -1; }); if (hasSomeColor) return componentMedia[i]; }
      for (var i = 0; i < componentMedia.length; i++) { altNorm = norm(componentMedia[i].alt || ''); hasSomeColor = colorWords.some(function(w){ return w.length > 2 && altNorm.indexOf(w) !== -1; }); if (hasSomeColor) return componentMedia[i]; }
      return null;
    }
    var colorMap = {};
    product.options[1].values.forEach(function(color) { var match = findMatch(color); if (match) colorMap[color] = sectionId + '-' + match.id; });
    var opt2Fieldset = null;
    document.querySelectorAll('.product-form__input').forEach(function(fs) {
      fs.querySelectorAll('input[type=radio]').forEach(function(inp) {
        if (product.options[1].values.indexOf(inp.value) !== -1) opt2Fieldset = fs;
      });
    });
    if (!opt2Fieldset) return;
    opt2Fieldset.addEventListener('change', function(e) {
      var color = e.target.value;
      var mediaId = colorMap[color];
      if (!mediaId) return;
      setTimeout(function() {
        var btn = document.querySelector('.thumbnail-list__item[data-target="' + mediaId + '"] button');
        if (btn) btn.click();
      }, 80);
    });
  });
});